import { App, DirectiveBinding, RendererElement } from "vue";
import { Fragments } from "@/front-tools/pretzel/index.ts";

export const PretzelPlugin = {
  install(Vue: App, options: any) {
    Vue.directive('fragment', {
      mounted: (el: RendererElement, binding: DirectiveBinding<string | {
        id?: string;
        index?: number;
        autoslide?: number;
        duration?: number;
      }>) => {
        el.dataset.fragment = "fragment"

        const b = binding.value
        if (b !== undefined) {
          if (typeof b === "string") {
            el.dataset.fragmentId = b;
          } else if (typeof b === "object") {
            if (b.id !== undefined) Fragments.setFragmentId(el, b.id);
            if (b.index !== undefined) Fragments.setFragmentIndex(el, b.index);
            if (b.autoslide !== undefined) Fragments.setFragmentAutoslide(el, b.autoslide);
            if (b.duration !== undefined) Fragments.setFragmentDuration(el, b.duration);
          }
        }
      },
    })
  }
}